import styled from '@emotion/styled';
import React from 'react';
import { MergeWithOverwrite } from 'src/common';
import { colors } from 'src/theme';

const IconSpan = styled.span<{ height: number; width: number }>(({ height, width }) => ({
  display: 'inline-flex',
  height,
  width,
}));

export type StarIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number;
  height?: number;
  color?: string;
}>;

export const StarIcon: React.FC<StarIconProps> = ({
  width = 14,
  height = 14,
  color = colors.secondary,
  ...props
}) => (
  <IconSpan height={height} width={width} {...props}>
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 1L7.09 4.26L10.5 4.26L7.7 6.48L8.41 9.74L6 8L3.59 9.74L4.3 6.48L1.5 4.26L4.91 4.26L6 1Z"
        fill={color}
      />
    </svg>
  </IconSpan>
);
